import cn from 'classnames';
import type { Product } from '@/domain/Product';
import styles from './FlavourProfile.module.scss';
import {
  getKnownProductSpecificationByKey,
  type PropertySpecification
} from '@/domain/Specification';

export type FlavourProfileProps = {
  product: Product;
};
export default function FlavourProfile({ product }: FlavourProfileProps) {
  const { specifications } = product;

  const bitternessSpec = getKnownProductSpecificationByKey<
    PropertySpecification | undefined
  >(specifications, 'bitterness');

  const aciditySpec = getKnownProductSpecificationByKey<
    PropertySpecification | undefined
  >(specifications, 'acidity');

  const roastLevelSpec = getKnownProductSpecificationByKey<
    PropertySpecification | undefined
  >(specifications, 'roastLevel');

  const bodySpec = getKnownProductSpecificationByKey<
    PropertySpecification | undefined
  >(specifications, 'body');

  if (!bitternessSpec && !aciditySpec && !roastLevelSpec && !bodySpec) {
    return null;
  }

  return (
    <section class={styles.container}>
      <div class={styles.barsWrapper}>
        <ProfileBar
          label={bitternessSpec?.title!}
          value={bitternessSpec?.value as number}
        />
        <ProfileBar
          label={aciditySpec?.title!}
          value={aciditySpec?.value as number}
        />
        <ProfileBar
          label={roastLevelSpec?.title!}
          value={roastLevelSpec?.value as number}
        />
        <ProfileBar
          label={bodySpec?.title!}
          value={bodySpec?.value as number}
        />
      </div>
    </section>
  );
}

type ProfileBarProps = {
  label: string;
  value: number | undefined;
};
function ProfileBar({ label, value }: ProfileBarProps) {
  if (value === undefined) {
    return null;
  }
  const bars = new Array(...Array(5));
  return (
    <>
      <div class={styles.label}>{label}</div>
      <div class={styles.bar}>
        {bars.map((_, index) => (
          <div
            class={cn(styles.barSegment, { [styles.barFilled]: index < value })}
            // eslint-disable-next-line react/no-array-index-key
            key={index}
          />
        ))}
      </div>
    </>
  );
}
